import React from 'react';
import type { SanityBlock } from '@sanity/client';
import { InformationSummary } from '@naf-simba/sections-information-summary';
import BlockContent from '../../../BlockContent';
import * as S from './InfoBox.styles';

export interface InfoBoxSerializerProps {
  value: {
    displayOption: 'standard' | 'green';
    highlightedText: string;
    title: string;
    text: SanityBlock[];
  };
}

export const InfoBoxBlock = ({ value }: InfoBoxSerializerProps) => (
  <S.InformationSummaryWrapper className="info-box">
    <InformationSummary
      variant="infobox"
      displayOption={value.displayOption}
      highlightedText={value.highlightedText}
      title={value.title}
      content={<BlockContent value={value.text} />}
    />
  </S.InformationSummaryWrapper>
);
